import { SortingState } from '@tanstack/react-table';
import { useMutation } from 'react-query';

import { exportCompletionPlanToCsv as mutationFn } from 'api/endPoints/exportCompletionPlanToCsv';

import { Pagination } from 'components/common/pagination/customPagination';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

export const useMutationExportCompletionPlanToCsv = () => {
    return useMutation<unknown, QueryError, QueryParams>({ mutationFn: (params) => mutationFn(params) });
};

interface QueryParams {
    params: {
        contractId: number | null | undefined;
        metaDataId: number | undefined;
        tabId: 'blocking' | 'delaying' | 'schedule' | 'completed' | 'all';
        filter: {
            filters: IFilter[];
        };
        sortingRequestList: SortingState;
        paging: Pagination;
    };
    fileName: string;
}
